var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vueSelect',{attrs:{"searchable":false,"options":_vm.data.values,"placeholder":_vm.transformedLabel},model:{value:(_vm.data.currentValue),callback:function ($$v) {_vm.$set(_vm.data, "currentValue", $$v)},expression:"data.currentValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }